// extracted by mini-css-extract-plugin
export var displayNone = "_rj-6";
export var imgContainer = "_rj-2";
export var overflowHidden = "_rj-3";
export var productInfoCardButtonContainer = "_rj-5";
export var productTitleText = "_rj-4";
export var rightArrow = "_rj-1";
export var rightArrowContainer = "_rj-0";